import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OpendialogCustomizeMySessionComponent } from 'app/components/dialog/open-dialog-customize-my-session/opendialog-customize-my-session.component';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';

@Component({
  selector: 'app-session-booked-overview-trainee',
  templateUrl: './session-booked-overview-trainee.component.html',
  styleUrls: ['./session-booked-overview-trainee.component.scss']
})
export class SessionBookedOverviewTraineeComponent implements OnInit {

  @Input() trainees: Trainee[];

  constructor(
    private dialog: MatDialog,
    private faIconService: FaiconService,
  ) { }

  ngOnInit(): void {
   }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  opendialogCustomizeMySession(offer: FullOffer): void {
    const { length: quantity } = this.trainees;
    const dialogRef = this.dialog.open(OpendialogCustomizeMySessionComponent, {
      data: {
        quantity,
        showError: false,
        trainees: this.trainees

      },
      minWidth: '50%',
      width: '100%',
      height: '80%',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe({
      next: () => { }
    });
  }

}
